const API_PREFIX = "/loyalty";

// CMS Endpoints - Zahtijevaju autentifikaciju
export const createLoyaltyPackageEndpoint = () => `${API_PREFIX}/packages`;
export const updateLoyaltyPackageEndpoint = (id: string) => `${API_PREFIX}/packages/${id}`;
export const getAllLoyaltyPackagesEndpoint = () => `${API_PREFIX}/packages`;
export const getLoyaltyPackageByIdEndpoint = (id: string) => `${API_PREFIX}/packages/${id}`;
export const deleteLoyaltyPackageEndpoint = (id: string) => `${API_PREFIX}/delete/${id}`;
export const revokeLoyaltyCodeEndpoint = (usageId: string) => `${API_PREFIX}/revoke/${usageId}`;
export const getLoyaltyStatisticsEndpoint = () => `${API_PREFIX}/statistics`;


// Online Rezervacije Endpoints - Ne zahtijevaju autentifikaciju
export const validateLoyaltyCodeEndpoint = () => `${API_PREFIX}/validate`;
export const applyLoyaltyCodeEndpoint = () => `${API_PREFIX}/apply`;